module.exports = __webpack_public_path__ + "static/media/top-right.2ef20f48.svg";